import { gql } from '@apollo/client'

export default gql(`
    query($input: [IntermediateMultipartUploadInput]) {
        batchGetIntermediateMultipartUploadUrl(input: $input )
    }
    `
)
